import { fetchAuthSession } from "aws-amplify/auth";

type AuthInfo = {
  token?: string;
  cognitoId?: string;
  expiration?: number;
};

let cachedAuthInfo: AuthInfo | null = null;

export const clearCachedAuthInfo = () => {
  cachedAuthInfo = null;
};

export const getCurrentAuthInfo = async () => {
  if (cachedAuthInfo) {
    const { expiration } = cachedAuthInfo;
    // Check if token is still valid (with 5 minute buffer time)
    if (expiration && expiration > Date.now() + 5 * 60 * 1000) {
      return cachedAuthInfo;
    }
  }

  const session = await fetchAuthSession({ forceRefresh: true });

  cachedAuthInfo = {
    token: session?.tokens?.idToken?.toString(),
    cognitoId: session.userSub,
    expiration: session.tokens?.idToken?.payload.exp! * 1000,
  };

  return cachedAuthInfo;
};
